<template>
    <div class="">
        <h5 class="info-head">战略信息</h5>
        <table border strip class="info-table">
            <tr>
                <th>序号</th>
                <th>产品及服务</th>
                <th>区域</th>
                <th>有效期</th>
            </tr>
            <tr v-for="(a, i) in agreements" :key="i">
                <td>{{i+1}}</td>
                <td>{{a.productName}}</td>
                <td>{{a.area}}</td>
                <td>{{a.canDate}}</td>
            </tr>
            <tr v-if="!agreements.length"><td colspan=10>暂无数据</td></tr>
        </table>


    </div>
</template>

<script type="text/babel">

    export default {
        name: 'supplier-agreement',
        data () {
            return {
                agreements: []
            }
        },
        methods: {
            getAgreementRes() {
                this.$http.get(`rest/api/completeFourInfo/getAgreementsByStockId?stockId=${encodeURIComponent(this.$root.stockId)}`).then((res) => {
                    if (res.data.result) {
                        this.agreements = res.data.value
                    }
                })
        }},
        created() {
            this.getAgreementRes();
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/dsp/supplier/Agreement.vue